import styled from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

export const InputWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: ${({ fullWidth, standardWidth }) =>
    fullWidth ? '100%' : standardWidth ? '320px' : 'auto'};
  margin-bottom: ${({ mb = 20 }) => mb}px;
  margin-top: ${({ mt = 0 }) => mt}px;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  ${respondTo.desktop`
    margin-top: ${({ desktopMt = 0 }) => desktopMt}px;
    margin-bottom: ${({ desktopMb = 20 }) => desktopMb}px;
  `}
`;

export const InputLabel = styled.span`
  position: absolute;
  top: 5px;
  left: 10.5px;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.17px;
  color: ${({ failed }) =>
    failed ? colors.theme.danger : colors.theme.primary_light};
  z-index: 9;
`;

export const InputError = styled.span`
  left: ${({ left = 6 }) => left}px;
  position: absolute;
  top: calc(100% + ${({ topOffset = 3 }) => topOffset}px);
  z-index: 9;

  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #df0b0b !important;
`;

export const InputTitle = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  position: relative;
  font-weight: 600;
  line-height: 1.5;
  color: #636262;
  max-width: 320px;
  margin-bottom: ${({ mb = 5 }) => mb}px;
  margin-top: ${({ mt = 0 }) => mt}px;
`;

export const InputDescription = styled.p`
  position: relative;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  color: #636262;
  margin-bottom: ${({ mb = 20 }) => mb}px;
  margin-top: ${({ mt = 0 }) => mt}px;
  max-width: 320px;
  ${respondTo.mobile`
    margin-top: 20px;
    margin-bottom: 20px;
  `}
`;

export const GridWrapper = styled.div`
  padding: ${({ mobile_pr = 0, mobile_pl = 0, mobile_pt = 0, mobile_pb = 0 }) =>
    `${mobile_pt}px ${mobile_pr}px ${mobile_pb}px ${mobile_pl}px`};
  flex: 1;
  margin-top: ${({ mt = 0 }) => mt}px;
  margin-bottom: ${({ mb = 0 }) => mb}px;

  ${respondTo.desktop`
    padding: ${({ pr = 20, pl = 20, pt = 0, pb = 0 }) =>
      `${pt}px ${pr}px ${pb}px ${pl}px`};
    display: ${({ d = 'grid' }) => d};
    flex-direction: ${({ direction = 'column' }) => direction};
    grid-gap: 0 20px;
    // grid-template-columns: repeat(2, 1fr);
        grid-template-columns: ${({
          columns = 'repeat(auto-fill, minmax(320px, 320px))',
        }) => columns};

    justify-content: ${({ justify = 'flex-start' }) => justify};
  `}
`;

export const Divider = styled.div`
  position: ${({ pos = 'relative' }) => pos};
  height: 1px;
  min-height: 1px;
  background-color: #ff7828;
  opacity: 0.3;
  margin-top: ${({ mt = 0 }) => mt}px;
  margin-bottom: ${({ mb = 0 }) => mb}px;

  ${respondTo.mobile`
    margin-top: ${({ mobileMt = 0 }) => mobileMt}px;
    margin-bottom: ${({ mobileMb = 0 }) => mobileMb}px;
  `}
`;

export const ConfigButton = styled.button`
  border-radius: 8px;
  background-color: #ff7828;
  width: 53px;
  height: 20px;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: bold;
  letter-spacing: -0.17px;
  text-align: center;
  color: #ffffff;
  margin-left: 20px;
  line-height: 20px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease all;

  &:hover {
    background-color: #ff9b1f;
  }
`;

export const RelativeBlock = styled.div`
  position: relative;
  margin-top: ${({ mt = 0 }) => mt}px;
  margin-bottom: ${({ mb = 0 }) => mb}px;
  padding: ${({ pr = 0, pl = 0, pt = 0, pb = 0 }) =>
    `${pt}px ${pr}px ${pb}px ${pl}px`};

  ${respondTo.mobile`
      margin-top: ${({ mobile_mt = 0 }) => mobile_mt}px;
  `}
`;

export const MenuWrapper = styled.div`
  padding: 0 20px;
`;

export const ListWrapper = styled.div`
  padding: 0 20px 20px 20px;
  ${respondTo.mobile`
    padding: 0;
  `}
`;

export const Title = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: #636262;
  margin-bottom: ${({ mb = 0 }) => mb}px;
  text-align: ${({ textAlign }) => textAlign};
`;

export const Description = styled(Title)`
  font-size: 14px;
  font-weight: normal;
  margin: ${({ mt = 5, mr = 0, mb = 20, ml = 0 }) =>
    `${mt}px ${mr}px ${mb}px ${ml}px `};
  text-transform: ${({ transform = 'unset' }) => transform};
`;

export const BoldTitle = styled(Title)`
  font-size: 24px;
  margin: 20px 0;
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  position: relative;
`;

export const ListBox = styled.div`
  flex: 1;
`;

export const ListItemDivider = styled.div`
  flex: 1;
  width: 100%;
  height: 1px;
  background-color: #ff7828;
  opacity: 0.3;
  position: absolute;
  bottom: 0;
`;

export const PrimaryWrapper = styled.div`
  padding: 0 20px;
  flex: 1;
  ${respondTo.mobile`
    padding: 0;
  `}
`;

export const ContentWrapper = styled.div`
  margin-top: 40px;
  ${respondTo.desktop`
    width: 100%;
    margin-top: 0;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
  `}
`;
